import {
  getLanguage,
  getPartnerId,
  getPartnerName,
  getCountryCode,
  getInstanceEnv,
} from '../../../shared/constants/globalConstants';

export { default as Banner } from './Banner';
export { default as Button } from '../../../components/Button';
export { default as TermsAndPolicySession } from './TermsAndPolicySession';
export { default as Appointments } from './Appointments';
export { default as DialogTelemed } from './DialogTelemed';
export { default as ConfirmEmailAlert } from './ConfirmEmailAlert';
export { default as TokboxVideoCall } from './TokboxVideoCall';

window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
  subsidiary_name: 'axa_partners',
  business_unit: 'customer_and_solutions',
  business_line: 'travel_solutions',
  digital_business_process: 'assistance_request',
  global_digital_asset: 'doctor_please',
  partner_id: getPartnerId(),
  partner_name: getPartnerName(),
  country: getCountryCode(),
  language: getLanguage(),
  instance_environment: getInstanceEnv(),
  user_logged: 'true',
  page_name: 'homepage',
  funnel_step: '0',
  step_name: 'homepage',
  event: 'pageview',
});
